import {
  DashboardDefinition,
  DashboardKey,
} from '@/app/pages/dashboard/models/dashboard.models';
import { CUSTOMER_DASHBOARD } from '@/app/pages/dashboard/templates/customer.template';
import { EXECUTIVE_DASHBOARD } from '@/app/pages/dashboard/templates/executive.template';
import { OPERATIONS_DASHBOARD } from '@/app/pages/dashboard/templates/operations.template';

export const DASHBOARD_REGISTRY: DashboardDefinition[] = [
  CUSTOMER_DASHBOARD,
  OPERATIONS_DASHBOARD,
  EXECUTIVE_DASHBOARD,
];

export function getDashboardByKey(
  key: string
): DashboardDefinition | undefined {
  return DASHBOARD_REGISTRY.find((dashboard) => dashboard.key === key);
}

export function isValidDashboardKey(key: string): key is DashboardKey {
  return DASHBOARD_REGISTRY.some((dashboard) => dashboard.key === key);
}
